var _path, _rect, _circle, _rect2, _rect3, _circle2, _rect4, _rect5, _rect6, _circle3, _rect7, _rect8, _circle4, _rect9, _rect10, _rect11, _circle5, _rect12, _rect13, _circle6, _rect14, _rect15, _rect16, _circle7, _rect17, _rect18, _circle8, _rect19, _rect20, _rect21, _circle9, _rect22, _rect23, _circle10, _rect24, _rect25, _rect26, _circle11, _rect27, _rect28, _circle12, _rect29, _rect30, _rect31, _circle13, _rect32, _rect33, _circle14, _rect34, _rect35, _rect36, _circle15, _rect37, _rect38, _circle16, _rect39, _rect40, _rect41, _circle17, _rect42, _rect43, _circle18, _rect44, _rect45;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFixturesEmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 569,
    height: 409,
    viewBox: "0 0 569 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.362 3.53967C442.024 16.726 454.889 77.8292 496.785 119.157C524.431 146.427 562.29 168.953 567.726 201.183C573.815 237.282 557.675 271.881 527.769 302.845C485.887 346.209 447.435 411.72 367.362 408.638C286.608 405.531 285.484 325.485 225.32 291.206C157.39 252.501 24.1724 257.537 3.25602 201.183C-17.8529 144.309 67.9247 93.7863 137.941 55.7802C202.1 20.9535 285.988 -10.832 367.362 3.53967Z",
    fill: "#081725"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.6435,
    y: 92.2441,
    width: 176.346,
    height: 68.263,
    rx: 7.79546,
    fill: "#989D99"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.416,
    cy: 115.63,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5474,
    y: 136.887,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4382,
    y: 148.128,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.568,
    cy: 115.63,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 125.699,
    y: 136.887,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108.59,
    y: 148.128,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 196.47,
    y: 92.2441,
    width: 176.346,
    height: 68.263,
    rx: 7.79546,
    fill: "#989D99"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.243,
    cy: 115.63,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 228.374,
    y: 136.887,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 211.265,
    y: 148.128,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.395,
    cy: 115.63,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 311.526,
    y: 136.887,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 294.417,
    y: 148.128,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 382.297,
    y: 92.2441,
    width: 176.346,
    height: 68.263,
    rx: 7.79546,
    fill: "#26333D"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.07,
    cy: 115.63,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 414.201,
    y: 136.887,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 397.092,
    y: 148.128,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.222,
    cy: 115.63,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 497.353,
    y: 136.887,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 480.244,
    y: 148.128,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6434,
    y: 169.988,
    width: 176.346,
    height: 68.263,
    rx: 7.79546,
    fill: "#26333D"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.4159,
    cy: 193.374,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5474,
    y: 214.63,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4382,
    y: 225.872,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.568,
    cy: 193.374,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 125.699,
    y: 214.63,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 108.59,
    y: 225.872,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 196.471,
    y: 169.988,
    width: 176.346,
    height: 68.263,
    rx: 7.79546,
    fill: "#989D99"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.243,
    cy: 193.374,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 228.374,
    y: 214.63,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 211.265,
    y: 225.872,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.395,
    cy: 193.374,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 311.526,
    y: 214.63,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 294.417,
    y: 225.872,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 382.298,
    y: 169.988,
    width: 176.346,
    height: 68.263,
    rx: 7.79546,
    fill: "#26333D"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.07,
    cy: 193.374,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 414.201,
    y: 214.63,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 397.092,
    y: 225.872,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.222,
    cy: 193.374,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 497.354,
    y: 214.63,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 480.244,
    y: 225.872,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6434,
    y: 247.732,
    width: 176.346,
    height: 68.263,
    rx: 7.79546,
    fill: "#26333D"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.4159,
    cy: 271.118,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5474,
    y: 292.375,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 25.4382,
    y: 303.616,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.568,
    cy: 271.118,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 125.699,
    y: 292.375,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 108.59,
    y: 303.616,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 196.471,
    y: 247.732,
    width: 176.346,
    height: 68.263,
    rx: 7.79546,
    fill: "#26333D"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.243,
    cy: 271.118,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 228.374,
    y: 292.375,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 211.265,
    y: 303.616,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 326.395,
    cy: 271.118,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 311.526,
    y: 292.375,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 294.417,
    y: 303.616,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 382.298,
    y: 247.732,
    width: 176.346,
    height: 68.263,
    rx: 7.79546,
    fill: "#989D99"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 429.07,
    cy: 271.118,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 414.201,
    y: 292.375,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 397.092,
    y: 303.616,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 512.222,
    cy: 271.118,
    r: 15.5909,
    fill: "#E5E5D6"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 497.354,
    y: 292.375,
    width: 29.7376,
    height: 5.57579,
    rx: 2.7879,
    fill: "#4C565D"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 480.244,
    y: 303.616,
    width: 63.9561,
    height: 5.57579,
    rx: 2.7879,
    fill: "#E5E5D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixturesEmptyState);
export default __webpack_public_path__ + "static/media/fixtures-empty-state.cc98103ac62086009066e89b7875c395.svg";
export { ForwardRef as ReactComponent };